export default __webpack_public_path__ + "static/media/chevron-right-icon.b8fd16f3.svg";